/**
 * <site-header> — mobile nav drawer, search toggle, cart toggle,
 * cart-count sync, and the transparent-over-hero solid-on-scroll effect.
 */
class SiteHeader extends HTMLElement {
  connectedCallback() {
    this.header = this.querySelector('.header');
    this.navToggle = this.querySelector('[data-nav-toggle]');
    this.navClose = this.querySelector('[data-nav-close]');
    this.drawer = this.querySelector('[data-nav-drawer]');
    this.searchToggle = this.querySelector('[data-search-toggle]');
    this.themeToggle = this.querySelector('[data-theme-toggle]');
    this.cartToggle = this.querySelector('[data-cart-toggle]');
    this.sentinel = this.querySelector('[data-header-sentinel]');

    this.drawerOpen = false;
    this.sentinelVisible = true;

    this.navToggle?.addEventListener('click', () => this.openDrawer());
    this.navClose?.addEventListener('click', () => this.drawer?.close());

    this.drawer?.addEventListener('click', (event) => {
      // Click landed on the backdrop (the dialog element itself, not its content).
      if (event.target === this.drawer) this.drawer.close();
    });
    this.drawer?.addEventListener('close', () => this.onDrawerClose());

    this.searchToggle?.addEventListener('click', () => {
      document.querySelector('predictive-search')?.open();
    });

    this.themeToggle?.addEventListener('click', () => {
      const isLight = document.documentElement.getAttribute('data-theme') === 'light';
      const next = isLight ? 'dark' : 'light';
      document.documentElement.setAttribute('data-theme', next);
      try {
        localStorage.setItem('atelier-theme', next);
      } catch (e) {
        /* storage blocked — toggle still works for the session */
      }
    });

    this.cartToggle?.addEventListener('click', (event) => {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('cart:open'));
    });

    document.addEventListener('cart:updated', (event) => {
      const count = event.detail?.cart?.item_count;
      if (count === undefined) return;
      this.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.classList.toggle('is-empty', count === 0);
      });
    });

    if (this.sentinel && this.header?.classList.contains('header--transparent')) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.sentinelVisible = entry.isIntersecting;
          this.updateSolidState();
        });
      });
      observer.observe(this.sentinel);
    }
  }

  openDrawer() {
    if (!this.drawer || typeof this.drawer.showModal !== 'function') return;
    this.drawer.showModal();
    this.drawerOpen = true;
    this.updateSolidState();
    this.navClose?.focus();
  }

  onDrawerClose() {
    this.drawerOpen = false;
    this.updateSolidState();
    this.navToggle?.focus();
  }

  updateSolidState() {
    if (!this.header) return;
    this.header.classList.toggle('is-solid', this.drawerOpen || !this.sentinelVisible);
  }
}

if (!customElements.get('site-header')) {
  customElements.define('site-header', SiteHeader);
}
